import { useState, useEffect, useMemo } from "react";
import { ChildData } from "../../types";
import { getChildByGuid, retrieveSakChildCompletion } from "..";

interface UseChildDataReturn {
  childData: ChildData | null;
  loading: boolean;
  error: string | null;
  isCompletedSubmission: boolean;
}

export function useChildData(childId: string): UseChildDataReturn {
  const [childData, setChildData] = useState<ChildData | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const isCompletedSubmission = useMemo(
    () => (childId ? !!retrieveSakChildCompletion(childId) : false),
    [childId]
  );

  useEffect(() => {
    async function fetchChildData() {
      if (!childId) {
        setChildData(null);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const data = await getChildByGuid(childId);
        setChildData(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : "Failed to fetch child data");
        console.error("Error fetching child data:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchChildData();
  }, [childId]);

  return { childData, loading, error, isCompletedSubmission };
}
